module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_arrow_down.9d68c8b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_arrow_down.svg
// module id = 3176
// module chunks = 0